import React, { useState, useEffect } from 'react';
import './styles.css';
import { ReactComponent as CloseIcon } from "common/assets/svg/wrong.svg";
import  CloseIco from "common/assets/svg/wrong.svg";

const ConfirmationPopup = ({ onClose,onSubmit,updatedMenu }:any) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };
  
  const handleOnSubmit = () => {
    setIsOpen(false);
    onSubmit(updatedMenu);
  };
  

  return (
    <>
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup">
            <div className="popup-header">
              <span className="popup-title">Warning</span>
              <button className="close-button" onClick={handleClose}>
                {/* <img src={CloseIco} /> */}
              <CloseIcon />
              </button>
            </div>  
            <div className="popup-content">
              {/* Your popup content goes here */}
              <p>Switching order type or refreshing the page will result in clearing the cart. Do you want to proceed?</p>
            </div>
            <div className='popup-button-contianer'>
                <button className="sad-button" onClick={handleClose}>
                   Cancel
                </button>
                <button className="happy-button" onClick={handleOnSubmit}>
                    Proceed
                </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmationPopup;
